import React from 'react'

const OutsourcingMainContant = () => {
    return (
        <>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-6 services-details mt-3">
                            <div className="ml-about-content">
                                <h1>Top Outsource Software Development Company for Your Next Project</h1>
                                <div className="bar" />
                                <p>
                                    In today's world, National boundaries are dissolved in the software industry. Creating a global scenario to hire and Keep the best talent wherever found. We, at Alobha Technologies, Leading <b>Outsouce Software Development Company</b>, can set up a dedicated development team for you. We offer this dedicated developer model to such
                                    clients who are looking to use the resources full time as an
                                    extension of their development team.
                                </p>
                                <p>
                                    The key benefits of outsourcing your software projects to Alobha, a
                                    software development company, based in India, are the immediate
                                    access to a vast pool of best industry talents with low exit cost
                                    and no management cost and other etc. Our <b>Software outsourcing service</b> will offer your company a great range of flexibility which improve efficiency of your staff allocation. By outsourcing we can utilize the flexible manpower and can reduce the HR cost.
                                </p>
                                <p>
                                    The team can be as small as one programmer analyst and two
                                    programmers to maximum people with the skill set which is required
                                    by you. We make sure that the each Developing member has the
                                    experience and knowledge of the development and quality standard.
                                    The quality of development would be very high. Our model allows the
                                    customers to obtain full control over development processes,
                                    resources and results with the minimum investment. The contract
                                    duration is wholly dependent on client’s choice but we advise to
                                    hire a dedicated team for a minimum of three to six months. Some of
                                    the features of this model can be seen as.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-desc">
                            <div className="services-details-accordion">
                                <ul className="accordion mb-3">
                                    <li className="accordion-item">
                                        <a className="accordion-title" href="javascript:void(0)">
                                            Simple monthly billing cycles
                                        </a>
                                        {/* <p class="accordion-content show">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                    </li>
                                    <li className="accordion-item">
                                        <a className="accordion-title" href="javascript:void(0)">
                                            Daily / weekly reporting
                                        </a>
                                        {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                    </li>
                                    <li className="accordion-item">
                                        <a className="accordion-title" href="javascript:void(0)">
                                            Project Manager overlooking overall progress
                                        </a>
                                        {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                    </li>
                                    <li className="accordion-item">
                                        <a className="accordion-title" href="javascript:void(0)">
                                            Direct reporting to clients' project coordinators
                                        </a>
                                        {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                    </li>
                                    <li className="accordion-item">
                                        <a className="accordion-title" href="javascript:void(0)">
                                            Source code ownership at all times
                                        </a>
                                        {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                    </li>
                                    <li className="accordion-item">
                                        <a className="accordion-title" href="javascript:void(0)">
                                            Full Intellectual Property Rights Protection
                                        </a>
                                        {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                    </li>
                                </ul>
                                <p>
                                    Software outsourcing is a process of engaging third party
                                    professionals and developer for software development services. Often
                                    the complete process is managed and supervised by the company which
                                    outsources its development requirements. As a set rule third party
                                    software professional are hired on contract to develop your
                                    application as per your exact requirements.
                                </p>
                                <p>
                                    We work with you to overcome a particular business challenges in a
                                    way that satisfies your needs for speed, cost effectiveness and high
                                    quality.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <div className="ml-about-content mt-4">
                                    <h2>Ecommerce Website Development</h2>
                                    <div className="bar" />
                                    <p>
                                        We not only develop websites. we try to build online image of your
                                        company in front world. Alobha technology has been developing
                                        ecommerce website design for over the years An eCommerce website
                                        is a vital part of any retailers channel mix in fact for some, it
                                        may be your only sales channel That means you need a site that’s
                                        easy to use, processes payments securely and which showcases your
                                        products in the best way possible.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/e-commerce.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="separate" />
                    <div className="row align-items-center mb-4">
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/backend.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <div className="ml-about-content mt-4">
                                    <h2>Backend Development</h2>
                                    <div className="bar" />
                                    <p>
                                        Web Development is one of the fastest growing domains in IT
                                        industry Our web development solutions will transform and grow
                                        your business.Our service is personal and tailored to each
                                        individual client. We define your needs and understand your target
                                        audience, so we can deliver benefits that will give your project
                                        the success it deserves.“Every project we undertake is unique and
                                        every client we work with requires a different approach. Our small
                                        size and network of trusted partners and Developer enable us to
                                        offer flexibility and reliability.”
                                    </p>
                                    <div className="services-details-accordion">
                                        {/* <ul className="accordion">
                                            <li className="accordion-item">
                                                <a className="accordion-title" href="javascript:void(0)">
                                                    Which material types can you work with?
                                                </a>
                                            </li>
                                            <li className="accordion-item">
                                                <a className="accordion-title" href="javascript:void(0)">
                                                    Is Smart Lock required for instant apps?
                                                </a>
                                            </li>
                                            <li className="accordion-item">
                                                <a className="accordion-title" href="javascript:void(0)">
                                                    Can I have multiple activities in a single feature?
                                                </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default OutsourcingMainContant